// @vendors
import Cookies from 'js-cookie';

// @constants
const {
  TOKEN_COOKIE,
  API_URL,
} = require('constants/index');

const initNotificationManagement = (environmentConfig, idController = null) => {
  return {
    apiUrl: API_URL,
    environmentConfig,
    idController,
    configHeader: {
      openBankAuthToken: JSON.parse(Cookies.get(TOKEN_COOKIE)),
      'Content-Type': 'application/json',
    },
  };
};

module.exports = {
  initNotificationManagement,
};
